var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangleGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 108,
    viewBox: "0 0 1440 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 67.2291C0 49.8677 13.8439 35.6732 31.1998 35.2391L1407.2 0.820449C1425.18 0.370685 1440 14.824 1440 32.8104V108H0V67.2291Z",
    fill: "#F6F8FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleGrey);
export default __webpack_public_path__ + "static/media/RectangleGrey.97d3f2e8887ee97799306fb02f04c57f.svg";
export { ForwardRef as ReactComponent };